/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Inject, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './political-campaign-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {formatAdnStat} from '../common/filters/format-adn-stat';
import {AppLocaleService} from '../common/locale/app-locale.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {PoliticalCampaignApiService, PoliticalCampaignModel} from './political-campaign-api.service';
import {AppSharedModule} from '../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-political-campaign-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PoliticalCampaignListPageComponent implements OnInit {
  readonly itemStateName = 'app.pol.political-campaigns.political-campaign';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'politicalEntity', labelInstant: 'Political Entity', sortable: false},
    {param: 'election', sortable: false},
    {param: 'totalBudget', labelInstant: 'Total Budget', sortable: false},
    {param: 'ownerTeam', labelInstant: 'Owner team', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly appLocale: AppLocaleService
  ) {}

  readonly list = inject(SignalAdminResourceListStateFactory).create<PoliticalCampaignModel>(
    inject(PoliticalCampaignApiService),
    {listId: 'fullPoliticalCampaignList', searchFields: 'name;description'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }

  refLabel(value: any): string {
    return (value && value.name) || value || '';
  }

  formatStat(value: any): string {
    return formatAdnStat(value, undefined, undefined, undefined, this.LocalNetworkProfile.get('defaultCurrency'), this.appLocale.getLocaleId());
  }
}
